module.exports = [{
      plugin: require('/Users/dawid/Projects/DS/dsplatform-documentation/node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"/Users/dawid/Projects/DS/dsplatform-documentation/src/templates/docs.js"},
    },{
      plugin: require('/Users/dawid/Projects/DS/dsplatform-documentation/node_modules/gatsby-mdx/gatsby-browser.js'),
      options: {"plugins":[],"gatsbyRemarkPlugins":[{"resolve":"gatsby-remark-images","options":{"maxWidth":1035,"sizeByPixelDensity":true}},{"resolve":"gatsby-remark-copy-linked-files"}],"extensions":[".mdx",".md"]},
    },{
      plugin: require('/Users/dawid/Projects/DS/dsplatform-documentation/node_modules/gatsby-plugin-emotion/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/dawid/Projects/DS/dsplatform-documentation/node_modules/gatsby-plugin-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":null,"head":true,"anonymize":false},
    }]
